import React, { useState } from 'react';
import AddDeviceChargerCredentialModal from '../api-credential/AddDeviceChargerCredentialModal';
import { Facility } from '@reliance/types/models/Facility';

type AddDeviceChargerCredentialProps = {
  facility: Facility
}

const AddDeviceChargerCredential: React.FC<AddDeviceChargerCredentialProps> = (props) => {
  const { facility } = props;

  const [showModal, setShowModal] = useState(false);

  const hasCredential = (facility.apiCredentials||[]).filter(c => c.userType == 'device_charger').length > 0;

  return (
    <>
      <button
        className="btn btn-secondary"
        onClick={() => setShowModal(!showModal)}
        disabled={hasCredential}>
        {hasCredential ? 'Charger Credential Exists' : 'Add Charger Credential'}
      </button>
      {showModal &&
        <AddDeviceChargerCredentialModal
          onClose={() => setShowModal(false)}
          facility={facility} />
      }
    </>
  );
}

export default AddDeviceChargerCredential;
